/**
 * Created by sange on 15/08/2017.
 */

import { createEntityAdapter, EntityState } from '@ngrx/entity'

import * as usersActions from '../actions/users.actions'
import * as membersActions from '../actions/members.actions'

import { VendorUserV1 } from '../../../../api/api/models/vendor-user-v1'

export interface State extends EntityState<VendorUserV1> {
  loading: boolean
}

export const adapter = createEntityAdapter<VendorUserV1>({
  selectId: (user: VendorUserV1) => user.id,
  sortComparer: false
})

export const initialState: State = adapter.getInitialState({
  loading: false
})

export function reducer(state = initialState,
                        action: usersActions.UsersActions | membersActions.MembersActions): State {
  switch (action.type) {

    case usersActions.LOAD_CREATED_USER: {
      return {...state, loading: true}
    }

    case usersActions.LOAD_USERS: {
      return {
        ...adapter.removeAll(state),
        loading: true,
      } as State
    }

    case usersActions.LOAD_USERS_SUCCESS: {
      return {
        ...adapter.addAll(action.payload.users, state),
        loading: false,
      } as State
    }

    case usersActions.LOAD_CREATED_USER_SUCCESS: {
      return {
        ...adapter.addOne(action.payload.user, state),
        loading: false,
      } as State
    }

    case usersActions.UPDATE_USER_SUCCESS: {
      const {user} = action.payload
      const oldUser = state.entities[user.id]
      return {
        ...adapter.updateOne({
          id: user.id,
          changes: {
            ...oldUser,
            ...user
          }
        }, state)
      } as State
    }

    case membersActions.ADD_TEAM_MEMBER_SUCCESS: {
      const {teamMember} = action.payload
      const foundUser = state.entities[teamMember.vendorUser.id]

      if (foundUser) {
        return state
      }
      return adapter.addOne(teamMember.vendorUser, state)
    }

    default: {
      return state
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/team/store/reducers/users.reducer.ts